import React from 'react';
import { Card, CardContent } from './ui/card';
import { Truck, Cog, Clock, Shield } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: Truck,
      title: 'Traslado de Vehículos Ligeros',
      description: 'Servicio especializado para automóviles, camionetas y vehículos livianos. Traslado seguro con equipos modernos.',
      image: 'https://customer-assets.emergentagent.com/job_crane-services-4/artifacts/o0cteepb_file_000000002a40720e986fc1a5a8f48f9d%20%282%29.png'
    },
    {
      icon: Truck,
      title: 'Traslado de Vehículos Pesados',
      description: 'Grúas especializadas para camiones, buses y vehículos de gran porte. Máxima seguridad garantizada.',
      image: 'https://customer-assets.emergentagent.com/job_crane-services-4/artifacts/kwg4tncx_Screenshot_20260222_034051_Gallery.jpg'
    },
    {
      icon: Cog,
      title: 'Traslado de Maquinaria Industrial',
      description: 'Transporte de maquinaria pesada y equipamiento industrial. Personal capacitado y equipo adecuado.',
      image: 'https://customer-assets.emergentagent.com/job_crane-services-4/artifacts/ya87o7d3_Screenshot_20260222_034045_Gallery.jpg'
    }
  ];

  const features = [
    {
      icon: Clock,
      title: 'Servicio Rápido',
      description: 'Respuesta inmediata a tu llamado. Estamos disponibles de 06:00 a 00:30 todos los días.'
    },
    {
      icon: Shield,
      title: 'Seguridad Garantizada',
      description: 'Equipos modernos y personal capacitado para el cuidado de tu vehículo o maquinaria.'
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Soluciones profesionales de traslado para todo tipo de vehículos y maquinaria en Mendoza
          </p>
        </div>

        {/* Main Services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="overflow-hidden hover:shadow-xl transition-shadow duration-300 border-gray-200"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  <div className="p-3 bg-gray-900 rounded-lg">
                    <service.icon className="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Features */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {features.map((feature, index) => (
            <Card key={index} className="border-gray-200">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="p-3 bg-gray-100 rounded-lg flex-shrink-0">
                    <feature.icon className="w-6 h-6 text-gray-900" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
